import { NextPage } from 'next'
import LoadingSpinner from 'componentsUnits/spinner'
import styles from '../styles/isLoading.module.scss'

const IsLoading: NextPage = () => {
  return <div className={styles.container}>
    <LoadingSpinner />
  </div>
}

export default IsLoading
